module.exports = __webpack_public_path__ + "img/Products_Desktop_05.ffb87fe4.jpg";